import React from 'react';
import { Box, Container, Flex, Title, Button } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function SimpleHeader() {
  const navigate = useNavigate();

  return (
    <Box>
      <header
        style={{
          padding: '20px 0',
          background: '#ffffff',
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
          marginBottom: '20px'
        }}
      >
        <Container size="xl">
          <Flex justify="space-between" align="center">
            {/* Logo and Title */}
            <Flex align="center" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
              <img
                src="/logo.png"
                alt="Sort My Shoebox Logo"
                style={{ height: 40, marginRight: 16 }}
              />
              <Title
                c="black"
                order={1}
                style={{
                  fontFamily: 'Bebas Neue',
                  fontSize: 32
                }}
              >
                SORT MY SHOEBOX
              </Title>
            </Flex>

            {/* Navigation Links */}
            <Flex gap="md">
              <Button variant="subtle" onClick={() => navigate('/')}>
                Home
              </Button>
              <Button variant="subtle" onClick={() => navigate('/blog')}>
                Blog
              </Button>
              <Button variant="subtle" onClick={() => navigate('/faq')}>
                FAQ
              </Button>
            </Flex>
          </Flex>
        </Container>
      </header>
    </Box>
  );
}
